export type TipoAcessoAuditoria =
  | 'Nenhum'
  | 'Diagnostico'
  | 'Trial72h'
  | 'FullPremium'
  | 'Enterprise';

export const TIPOS_ACESSO_AUDITORIA: { value: TipoAcessoAuditoria; label: string }[] = [
  { value: 'Nenhum',      label: 'Nenhum (sem acesso)' },
  { value: 'Diagnostico', label: 'Diagnóstico — Camada 1 (totais e mapa de calor)' },
  { value: 'Trial72h',    label: 'Trial 72 h — Camada 2 (100% dos dados, 12 módulos liberados)' },
  { value: 'FullPremium', label: 'Full Premium — Camada 3 (acesso total)' },
  { value: 'Enterprise',  label: 'Enterprise — Camada 3 + API Key' },
];

export interface IClienteAcessoAuditoria {
  statusAcesso: TipoAcessoAuditoria;
  statusAcessoEfetivo: TipoAcessoAuditoria;
  dataInicioTrial?: string;
  dataExpiracaoTrial?: string;
  trialExpirado: boolean;
  flagEnterprise: boolean;
  apiChave?: string;
  percentualVisualizacao: number;
}

export interface IClienteAcessoAuditoriaRequest {
  statusAcesso: TipoAcessoAuditoria;
}

export interface IClienteGerarApiChaveResponse {
  apiChave: string;
}
